<template>
<div class="chapter">
<div class="inner_page">
<p class="C147" style="margin-top:5%;"><strong><a id="page_xxi"></a>A<span class="small">NNALS OF A</span> Q<span class="small">UIET</span> N<span class="small">EIGHBOURHOOD</span></strong></p>
<p class="C148" style="margin-bottom:4%;"><strong>1867</strong></p>
<p class="C149">The Cullen Collection</p>
<p class="C150">Volume 6</p>
<p class="C94"><img alt="" height="auto" src="Images/image00246.jpeg" width="67%"/></p>
<p class="C94"><img alt="" height="auto" src="Images/image00247.jpeg" width="81%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0008.vue?738d6f5c